import { API } from '@xbto/api-client';
import { EnrichedFundFacts } from '../../types';
import { BigOrZero } from '../big';

export const enrichFundFacts = (
  facts: API.GetFundFactsResponse | null | undefined
): EnrichedFundFacts | null => {
  if (!facts) {
    return null;
  }

  return {
    ...facts,
    minimumInvestmentInKind: facts.minimumInvestmentInKind || '',
    minimumInvestmentUsd: facts.minimumInvestmentUsd || '',
    managementFee: BigOrZero(facts.managementFee),
    performanceFee: BigOrZero(facts.performanceFee),
  };
};
